export default __webpack_public_path__ + "static/media/HDTX_Pengumuman RUPS 2023.0ef14884.pdf";